import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateBonuses = (params) => {
    return axios.post(`${backendHost}/api/admin/bonuses/create`, params);
};

export {
    postCreateBonuses
}